import { Component, OnInit, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { SchedulerService } from '../scheduler.service';
import { TranslateService } from '@ngx-translate/core';

import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import moment from 'moment';
import { TreatmentType, ApiResponseCode, TreatmentStatus, ConfirmeAppointmentTypes, Gender } from 'src/app/core/enums';
import { TreatmentModel } from 'src/app/core/models/treatment-model';
import { ColorLabel } from 'src/app/core/interfaces/color-label';
import { VisitReason } from 'src/app/core/interfaces/visit-reason';
import { Room } from 'src/app/core/interfaces/room';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { Utils } from 'src/app/core/utils';
import { AppData } from 'src/app/app.data';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { TreatmentService } from '../../treatments/treatment.service';
import { TreatmentsModule } from '../../treatments/treatments.module';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MatDialog } from '@angular/material/dialog';
import { AvailableBalanceDialogComponent } from '../../available-balance-dialog/available-balance-dialog.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ErrorDialogComponent } from 'src/app/error/error-dialog/error-dialog.component';
import { CommonDialogComponent } from 'src/app/dialogs/common-dialog/common-dialog.component';
import { SchedulerModel } from 'src/app/core/models/scheduler.model';
import { ComplexBranch } from 'src/app/core/interfaces/complex-branch';
import { StandbyService } from '../../standby/standby.service';
import { ModulesService } from 'src/app/core/services/modules.service';
import { firstValueFrom } from 'rxjs';
import { EnterIdDialogComponent } from '../enter-id-dialog/enter-id-dialog.component';


@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss']
})
export class AppointmentDetailsComponent implements OnInit, OnDestroy {

  private sub: any;
  error: string;
  settings: Settings;
  form: UntypedFormGroup;
  minPrice = 0;
  maxPrice = 999999;
  eventID: number = 0;
  appointment: AppointmentModel = new AppointmentModel();
  rooms: Room[] = [];
  labels: ColorLabel[] = [];
  canceled: boolean = false;
  findTimeResultItem: FindTimeResultItem;
  patientID: number;
  patientName: string = '';
  age: string = '';
  //duration: number;
  gender: string = '';
  visitReason: string[] = [];
  phone: string = '';
  schedulerID: number;
  schedulerName: string;
  branchName: string;
  // branchID: number;
  start: moment.Moment;
  end: moment.Moment;
  confirmed: ConfirmeAppointmentTypes;
  arrived: boolean;
  noShow: boolean;
  paid: boolean;
  untouchedPaidStatus: boolean;
  balance: number = 0;
  isFinanceModuleEnabled: boolean = this.authService.modules.Finances;
  treatmentsPrev: TreatmentEntity[] = [];
  treatments: TreatmentEntity[] = [];
  priceListCodes: PriceListCode[] = [];
  isReasonRequired = true;
  schedulers: SchedulerModel[] = [];
  branches: ComplexBranch[] = [];
  currentScheduler: SchedulerModel;
  hasTreatmentsTodo: false;
  practiceID: number;
  isRoomRequired: boolean = false;
  minDuration = 5;
  maxDuration = 120;
  isWhatsAppEnabled: boolean = false;
  canChangeDuration: boolean = true;
  canChangeTime: boolean = true;

  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private authService: AuthenticateService,
    private schedulerService: SchedulerService,
    private standbyService: StandbyService,
    private treatmentService: TreatmentService,
    private findTimeService: FindTimeService,
    private customerService: CustomerService,
    private moduleService: ModulesService,
    public translate: TranslateService,
    private appData: AppData,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef) {

    this.settings = appSettings.settings;
    this.findTimeResultItem = appData.selectedFindTimeResultItem;
    this.treatments = appData.treatments || [];
    this.priceListCodes = appData.priceListCodes || [];

  }





  ngOnInit() {

    this.form = this.fb.group({
      hideRequired: false,
      floatLabel: 'auto',
      duration: [{ value: 30 }, Validators.compose([Validators.required, Validators.min(this.minDuration), Validators.max(this.maxDuration)])],
      price: [{ value: 0.00, disabled: true }, Validators.compose([Validators.required, Validators.min(this.minPrice), Validators.max(this.maxPrice)])],
      room: '',
      note: ['', Validators.maxLength(256)],
      selectedColor: null,
      sms: false,
      email: false,
      whatsapp: [{ value: false, disabled: false }],
      confirmed: [{ value: ConfirmeAppointmentTypes.None, disabled: false }],
      arrived: [{ value: false, disabled: false }],
      noShow: [{ value: false, disabled: false }],
      paid: [{ value: false, disabled: this.isFinanceModuleEnabled }]
    });

    this.toggleRoomRequiredValidator();

    this.setColorLabels();
    this.getBranches();

    this.sub = this.route.params.subscribe(params => {
      this.eventID = +params['id'] || 0; // (+) converts string 'id' to anumber
      this.loadDetails(this.eventID);

      // Check claims for existing appointments only
      if (this.eventID > 0) {
        this.canChangeDuration = !this.authService.claims.PreventAppointmentDurationChange;
        this.canChangeTime = !this.authService.claims.PreventAppointmentTimeChange;
      }

    });


  }

  updateDurationAndEndTime() {
    const duration = this.calcDurationByTreatments();
    this.setDuration(duration);
  }

  loadIsWhatsAppEnabledAsync(branchID: number) {

    if (!branchID || branchID <= 0) {
      return;
    }
    this.moduleService.isWhatsAppEnabled(branchID).subscribe({
      next: (result) => {
        if (result?.Code === ApiResponseCode.Success) {
          this.isWhatsAppEnabled = result.Data.IsWhatsAppEnabled;

          if (this.isWhatsAppEnabled) {
            this.f.whatsapp.enable();
          }
          else {
            this.f.whatsapp.setValue(false);
            this.f.whatsapp.disable();
          }

        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error: (err) => {
        this.error = err;
      }
    });
  }

  getBranches(practiceID?: number): void {
    console.log('Fetching branches...');

    this.standbyService.getBranches(practiceID).subscribe({
      next: (result) => {
        if (result?.Code === ApiResponseCode.Success) {
          this.branches = result.Data as ComplexBranch[];
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error: (err) => {
        this.error = err;
      }
    });
  }



  getSchedulers() {

    this.standbyService.getSchedulers().subscribe({
      next: (result) => {

        if (result.Code === ApiResponseCode.Success) {
          // success
          this.schedulers = result.Data.map(item => new SchedulerModel(item));
          this.appData.Schedulers = this.schedulers;
          this.currentScheduler = this.schedulers.find(x => x.ID == this.schedulerID);
          this.practiceID = this.currentScheduler?.PracticeID || 0;
          this.isReasonRequired = !(this.currentScheduler?.NoMandatoryVisitReason || false);
          this.updateDurationAndEndTime();
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error: (error) => {
        this.error = error;
      },
    });

  }

  getCustomerBalance(customerID: number) {

    this.balance = 0;

    if (customerID > 0) {
      this.customerService.getCustomerBalance(customerID).subscribe(
        result => {
          if (result.Code === 1) {
            // success           
            this.balance = result.Data.Balance;

          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        })
    }
  }


  updateResultFromTextEditor() {
    var treatment, data;
    // this.appData.textEditorData = JSON.stringify({obj: treatment, paramHTML: 'Description_HTML', paramTEXT: 'Description'});
    if (this.treatments && this.appData.textEditorData) {
      data = JSON.parse(this.appData.textEditorData);
      treatment = data.obj;
      for (let index = 0; index < this.treatments.length; index++) {
        const element = this.treatments[index];
        if (element.ID === treatment.ID) {
          this.treatments[index] = treatment;
          this.appData.textEditorData = '';
        }
      }
    }

    // update description in treatmentsFromCard
    if (treatment && this.appointment.TreatmentsFromCard) {
      var treatmentsFromCard: TreatmentModel[] = JSON.parse(this.appointment.TreatmentsFromCard);
      if (treatmentsFromCard) {
        for (let index = 0; index < treatmentsFromCard.length; index++) {
          const element = treatmentsFromCard[index];
          if (element.ID === treatment.ID) {
            treatmentsFromCard[index].Description_HTML = treatment.Description_HTML;
            treatmentsFromCard[index].Description = treatment.Description;
          }
        }
        this.appointment.TreatmentsFromCard = JSON.stringify(treatmentsFromCard);
        this.appData.appointment = this.appointment;
      }
    }
  }

  treatmentsFromCard_UnatachFromAppointment(treatment) {
    treatment.Selected = false;

    var treatmentsFromCard: TreatmentModel[] = JSON.parse(this.appointment.TreatmentsFromCard);
    if (treatmentsFromCard) {
      for (let index = 0; index < treatmentsFromCard.length; index++) {
        const element = treatmentsFromCard[index];
        if (element.ID === treatment.ID) {
          treatmentsFromCard[index].Selected = false;
          //treatmentsFromCard[index].Deleted = true; // we dont wnat to delete
        }
      }
      this.appointment.TreatmentsFromCard = JSON.stringify(treatmentsFromCard);
      this.appData.appointment = this.appointment;
    }
  }

  treatmentsFromCard_UnatachAllFromAppointment() {
    var treatmentsFromCard: TreatmentModel[] = JSON.parse(this.appointment.TreatmentsFromCard);
    if (treatmentsFromCard) {
      for (let index = 0; index < treatmentsFromCard.length; index++) {
        const element = treatmentsFromCard[index];
        treatmentsFromCard[index].Selected = false;
      }
      this.appointment.TreatmentsFromCard = JSON.stringify(treatmentsFromCard);
      this.appData.appointment = this.appointment;
    }
  }

  getTreatmentVisitReason(treatment: TreatmentEntity) {
    return Utils.treatmentToString(treatment, this.translate);
  }

  setColorLabels() {
    if (this.appData.ColorLabels && this.appData.ColorLabels.length > 0) {
      this.labels = this.appData.ColorLabels;

    } else {
      this.loadColors();
    }
  }

  loadDetails(eventId: number) {
    if (eventId > 0) {
      this.schedulerService.getEvent(eventId).subscribe(
        result => {

          if (result.Code === 1) {
            // success
            this.appointment = new AppointmentModel(result.Data);

            if (this.appData.appointment && this.appData.appointment.EventID === this.appointment.EventID) {
              this.appointment = new AppointmentModel(this.appData.appointment);

            } else {
              this.appData.appointment = this.appointment;

            }

            this.loadIsWhatsAppEnabledAsync(this.appointment.BranchID);
            this.getSchedulers();
            this.getAvailableRooms(this.appointment);
            this.fillFormByAppointment(this.appointment);
            this.updateResultFromTextEditor();
            this.getCustomerBalance(this.appointment.EntityID);
            this.checkIfHasTodoTreatments(this.appointment.EntityID);
            this.updateDurationAndEndTime();

          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        })
    };
  }



  getDatePart(date: moment.Moment) {
    return date.startOf('day');
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(formValue) {

    if (!this.canceled) {

      this.appointment.Start = this.start;
      this.appointment.End = this.end;
      this.appointment.Duration = this.f.duration.value;
      this.appointment.EndTime = this.end.format('HH:mm'); // this.end.format('LT');
      this.appointment.Hours = this.start.format('HH');
      this.appointment.Minutes = this.start.format('mm');

      this.appointment.EntityID = this.patientID;
      this.appointment.PriceListRefID = 0; //  this can be canceled later we use treatments  this.visitReason ? this.visitReason.PriceListRefID : 0;
      this.appointment.Price = formValue.price;
      this.appointment.Description = formValue.note;
      this.appointment.NotifyBySms = formValue.sms;
      this.appointment.NotifyByEmail = formValue.email;
      this.appointment.NotifyByWhatsApp = formValue.whatsapp;
      this.appointment.Confirmed = formValue.confirmed;
      this.appointment.Arrived = formValue.arrived;
      this.appointment.NoShow = formValue.noShow;
      this.appointment.Paid = formValue.paid;
      this.appointment.SchedulerRoomID = formValue.room;

      this.appointment.SchedulerID = this.schedulerID;
      this.appointment.SchedulerRoomID = this.f.room.value;
      // this.appointment.BranchID = this.branchID;


      this.appointment.Treatments = this.treatments;


      // if opened from find-time and treatment selected, visitItem.Treatments incase of making appointment from history
      const treatments = this.appData.treatments.length > 0 ? this.appData.treatments : this.appData.visitItem ? this.appData.visitItem.Treatments : [];

      if (treatments && treatments.length > 0) {
        treatments.forEach(trt => {
          trt.Selected = true;
        });

        this.appointment.TreatmentType = treatments[0].ParentTypeID;
        const therapistID = this.schedulerID; // this.getTherapistID(this.schedulerID);

        const treatmentModelCollection = treatments.map(entity => {

          const model = new TreatmentModel(entity);
          model.Selected = entity.Selected || false;
          model.Deleted = entity.Deleted;
          model.TreatmentCodeID = entity.CodeID;
          model.TreatmentCode = entity.PriceListCodeName || '';
          model.TreatmentCodeDescription = entity.Description || '';
          model.PriceList = { Text: '', Value: entity.PriceListID.toString() };
          model.Therapist = { Text: '', Value: therapistID.toString() };

          model.Duration = entity.PriceListCode.Duration;
          model.TreatmentStatusID = TreatmentStatus.ToDo;
          return model;
        });
        // send as string
        this.appointment.TreatmentsFromCard = JSON.stringify(treatmentModelCollection);
      }

      // if open from find-time and pricelistCode seleted
      const pricelistCode = this.appData.priceListCodes;
      if (pricelistCode && pricelistCode.length > 0) {
        // TreatmentsFromPriceList => List of TreatmentModel must set pricelistRefID and Selected
        const treatmentModelCollection = pricelistCode.map(x => {
          this.appointment.TreatmentType = x.TypeID;
          const model = new TreatmentModel();
          model.PriceListRefID = x.PriceListRefID;
          model.Selected = true;

          model.Duration = x.Duration;
          model.PriceList = { Text: '', Value: x.PriceListID.toString() };
          model.Price = x.FinalPrice || 0;
          model.TreatmentCodeID = x.ID;
          model.TreatmentCode = x.Code;
          model.TreatmentCodeName = x.Name;
          model.TreatmentCodeDescription = x.Description;

          const therapistID = this.schedulerID; // this.getTherapistID(this.schedulerID);
          model.Therapist = { Text: '', Value: therapistID.toString() };
          return model;
        });
        this.appointment.TreatmentsFromPriceList = JSON.stringify(treatmentModelCollection);

        // this can be deleted after removing from the model on the server
        this.appointment.PriceListRefID = 0;
      }

      if (formValue.selectedColor) {
        this.appointment.LabelColorID = (formValue.selectedColor as ColorLabel).ID;
      }
      else {
        this.appointment.LabelColorID = null;
      }

      this.update(this.appointment);
    }
  }



  isTreatmentDone(treatment: TreatmentEntity) {
    return treatment.TreatmentStatusID === TreatmentStatus.Done;
  }


  openDialogAvailableBalance(event, treatment: TreatmentEntity, data: any) {

    if (!data || !data.leftToPay) {
      return;
    }

    const currency = this.translate.instant('CURRENCY.' + data.currency);
    const businessCaption = this.translate.instant("TERMINOLOGY." + data.caption_business_resourceKey.toUpperCase());
    // get locale message for dialog
    const msg = this.translate.instant('MSG.TreatmentAvailableBalance', {
      leftToPay: data.leftToPay,
      currency: currency,
      availableBalance: data.availableBalance,
      businessCaption: businessCaption
    });

    // open confiramation dialog to delete
    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg + "?",
        treatmentID: treatment.ID
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // ok  
        this.setTreatmentDoneStep2(event, treatment, true);
      }
      else {
        this.setTreatmentDoneStep2(event, treatment, false);
      }
    });
  }

  setTreatmentDoneStep2(event, treatment: TreatmentEntity, updatePaid: boolean) {
    if (event.checked) {
      treatment.TreatmentStatusID = TreatmentStatus.Done;
    } else {
      treatment.TreatmentStatusID = TreatmentStatus.ToDo;
    }


    // update status in treatmentsFromCard
    if (this.appointment && this.appointment.TreatmentsFromCard) {
      var treatmentsFromCard: TreatmentModel[] = JSON.parse(this.appointment.TreatmentsFromCard);
      if (treatmentsFromCard) {
        for (let index = 0; index < treatmentsFromCard.length; index++) {
          const element = treatmentsFromCard[index];

          if (element.ID === treatment.ID) {
            treatmentsFromCard[index].TreatmentStatusID = treatment.TreatmentStatusID;
            treatmentsFromCard[index].IsDone = treatment.TreatmentStatusID === TreatmentStatus.Done;
          }
        }
        this.appointment.TreatmentsFromCard = JSON.stringify(treatmentsFromCard);
        this.appData.appointment = this.appointment;
      }
    }

    this.treatmentService.updateTreatmentStatus(treatment.ID, treatment.TreatmentStatusID, this.appointment.BranchID, updatePaid).subscribe(
      result => {
        this.getCustomerBalance(treatment.CustomerID);
        if (result.Data.showInventoryUpdated) {
          this.showInventorySavedDialog(result.Data.inventoryAutoUpdateError);
        }

      }
    );
  }

  setTreatmentDone(event, treatment: TreatmentEntity) {

    const checked = event.checked;

    if (checked) {
      this.treatmentService.canTransferAvailableBalanceForTreatment(treatment.ID).subscribe(
        result => {
          if (result.Code === 1) {
            if (result.Data && result.Data.leftToPay) {
              this.openDialogAvailableBalance(event, treatment, result.Data);
            }
            else {
              this.setTreatmentDoneStep2(event, treatment, false);
            }

          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        });
    }
    else {
      this.setTreatmentDoneStep2(event, treatment, false);
    }




  }
  enterTreatmentComment(event, treatment: TreatmentEntity) {

    event.preventDefault();
    this.appData.textEditorData = JSON.stringify({ obj: treatment, paramHTML: 'Description_HTML', paramTEXT: 'Description' });
    this.appData.navigateBackData = ['/appointment-details', this.eventID];
    this.router.navigate(['/text-editor', { id: treatment.ID }]);
  }

  update(appointment: AppointmentModel) {
    if (appointment.EventID === 0) {
      alert('invalid eventID');
      return;
    }
    this.settings.loadingSpinner = true;
    this.schedulerService.updateEvent(this.appointment).subscribe(result => {
      debugger;
      if (result.Code === ApiResponseCode.Success) {
        // success        
        this.appData.appointment = this.appointment;
        this.appData.navigateBackData = null;
        this.appData.textEditorData = '';
        this.router.navigate(['/appointment-saved', appointment.EventID]);

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        this.settings.loadingSpinner = false;
      }

    }, error => {
      this.error = error;
      this.settings.loadingSpinner = false;
    });
  }

  showEnterIdNumberDialog(customerID: number) {
    const dialogRef = this.dialog.open(EnterIdDialogComponent, {
      width: '300px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        customerID: customerID,
        idType: 1,
        idNumber: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'confirmed') {
        // if here id number was saved          

      } else {
        // enter id number was canceled
        this.onCancel(null);
      }
    });
  }

  onCancel($event: any) {
    this.canceled = true;
    this.appData.appointment = null;
    this.appData.navigateBackData = null;
    this.appData.textEditorData = '';
    this.appData.treatments = [];
    this.appData.priceListCodes = [];
    this.router.navigate(['/scheduler']);
  }


  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }

  // load available rooms for current branch and tome
  getAvailableRooms(appointment: any) {
    const branchID = appointment.BranchID;
    const date = new Date(appointment.Start);
    const startTime = this.getTime(new Date(appointment.Start));
    const endTime = this.getTime(new Date(appointment.End));
    const currentRoomID = appointment.SchedulerRoomID;

    this.schedulerService.getAvailableRooms(branchID, date, startTime, endTime, currentRoomID)
      .subscribe(result => {
        if (result.Code === 1) {
          //success
          this.rooms = result.Data as Room[];
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      }, error => {
        this.error = error;
      });
  }

  getTime(date: Date) {
    return Utils.getTime(date);
  }


  toDecimal(value: any) {
    // this function will be called on blur to fix number 4 => 4.00
    const val = Utils.toDecimal(value);
    this.f.price.setValue(val);
  }

  loadColors() {
    this.schedulerService.getColors().subscribe(result => {
      if (result.Code === 1) {
        // success
        this.labels = this.appData.ColorLabels;

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }

  fillFormByAppointment(appointment: AppointmentModel) {

    if (!appointment) {
      return;
    }

    this.start = appointment.Start;
    this.end = appointment.End;

    var entityData = appointment.getEntityData();
    this.patientID = entityData.EntityID;
    this.patientName = entityData.EntityName;
    this.age = entityData.Age || '';
    this.phone = entityData.Mobile;
    this.gender = entityData.Gender == Gender.Male ? this.translate.instant('GENDER.MALE') :
      entityData.Gender == Gender.Female ? this.translate.instant('GENDER.FEMALE') :
        "";

    this.setDuration(appointment.Duration);

    // Disable controls based on claims
    if (!this.canChangeDuration) {
      this.f.duration.disable();
    }

    this.visitReason = this.appData.visitSummary(appointment.Treatments, []); // build string array of appointment treatments for display

    if (appointment.Treatments?.length > 0) {
      this.treatments = appointment.Treatments;
    }
    if (this.appData.treatments?.length > 0) {
      this.appData.treatments.forEach(trt => {
        if (!this.treatments.find(x => x.ID == trt.ID)) {
          this.treatments.push(trt);
        }
      });
    }

    this.treatmentsPrev = Object.assign([], appointment.Treatments); // clone array
    const pricelistcodes = JSON.parse(appointment.TreatmentsFromPriceList) || [];
    if (pricelistcodes.length > 0)
      this.priceListCodes = this.priceListCodes.concat(pricelistcodes);

    // only after selecting treatments or pricelistCodes update duration
    if (this.appData.treatments?.length > 0 || this.appData.priceListCodes.length > 0)
      this.updateDurationAndEndTime();

    this.schedulerID = appointment.SchedulerID;
    this.schedulerName = appointment.ScdName;
    this.branchName = appointment.BranchName;

    this.untouchedPaidStatus = appointment.Paid;

    this.f.price.setValue(appointment.Price);
    this.f.note.setValue(appointment.Description);
    this.f.sms.setValue(appointment.NotifyBySms);
    this.f.email.setValue(appointment.NotifyByEmail);
    this.f.whatsapp.setValue(appointment.NotifyByWhatsApp);
    this.f.confirmed.setValue(appointment.Confirmed);
    this.f.arrived.setValue(appointment.Arrived);
    this.f.noShow.setValue(appointment.NoShow);
    this.f.paid.setValue(appointment.Paid);

    this.updateColorLabelByCodeOrTreatment();

    if (appointment.LabelColorID > 0) {
      var colorItem = this.labels.filter(x => x.ID === appointment.LabelColorID)[0];
      this.f.selectedColor.setValue(colorItem);
    }

    if (appointment.SchedulerRoomID > 0) {
      this.f.room.setValue(appointment.SchedulerRoomID);
    }



    if (this.isFutureDate(appointment)) {
      // if here the event is in the future
      this.f.confirmed.enable();
      this.f.arrived.disable();
      this.f.noShow.disable();
    }

    // Disable duration field if PreventAppointmentDurationChange claim is set
    if (!this.canChangeDuration) {
      this.f.duration.disable();
    }

    this.toggleRoomRequiredValidator();
  }


  isFutureDate(appointment) {
    return Utils.isFutureDate(appointment.Start);
  }

  updateColorLabelByCodeOrTreatment() {
    const priceListCode = this.priceListCodes.filter(x => x.LabelColorID > 0)[0];
    if (priceListCode != null) {
      const selectedColor = this.labels?.filter(x => x.ID == priceListCode.LabelColorID)[0];
      if (selectedColor != null)
        this.f.selectedColor.setValue(selectedColor);
    }

    const treatmentFromCard = this.treatments.filter(x => x.PriceListCode?.LabelColorID > 0)[0];
    if (treatmentFromCard != null) {
      const selectedColor = this.labels?.filter(x => x.ID == treatmentFromCard.PriceListCode.LabelColorID)[0];
      if (selectedColor != null)
        this.f.selectedColor.setValue(selectedColor);
    }
  }

  canChangeTreatmentStatusToDone(treatment: TreatmentEntity) {

    // if treatment marked as Done the user can unmark end re-mark.
    const prev = this.treatments.filter(x => x.ID === treatment.ID)[0];
    var wasDone = prev && prev.TreatmentStatusID === TreatmentStatus.Done;
    if (wasDone) {
      return true;
    }

    // if here treatment status is not done
    // cannot change treatment status to 'Done' for future treatment.
    const startDate = moment(this.start).startOf('day'); // only date part (remove time part)
    const current = moment().startOf('day');
    const diff = startDate.diff(current, 'days');
    return diff < 1;
  }

  public get confirmeAppointmentType(): typeof ConfirmeAppointmentTypes {
    return ConfirmeAppointmentTypes;
  }

  onClick_markApptAs($event: any) {
    let targetMarkName = $event.currentTarget.getAttribute('for');

    switch (targetMarkName) {
      case 'confirmed':
        {
          if (this.f.confirmed.value !== ConfirmeAppointmentTypes.None) {
            this.f.confirmed.setValue(ConfirmeAppointmentTypes.None);
            this.confirmed = ConfirmeAppointmentTypes.None;
          } else {
            this.f.confirmed.setValue(ConfirmeAppointmentTypes.Confirmed);
            this.confirmed = ConfirmeAppointmentTypes.Confirmed;
          }
        }
        break;

      case 'arrived':
        {
          this.f.noShow.setValue(false);
          this.noShow = false;
        }
        break;

      case 'noShow':
        {
          this.f.arrived.setValue(false);
          this.arrived = false;
        }
        break;

      case 'paid':
        {
          if (!this.isFinanceModuleEnabled) {
            // set "true" to a flag for whether the paid status of the appointment was changed
            let setPaidStatus = !this.f.paid.value;
            let untouchedPaidStatus = this.untouchedPaidStatus;

            this.appointment.IsPaidStatusDirty = setPaidStatus !== untouchedPaidStatus;
          }
        }
        break;

      default:
        break;
    }
  }



  showNoPermissionDialog() {
    const msg = this.translate.instant('MSG.NO-PERMISSION-TO-CANCEL-APPOINTMENT');

    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });
  }

  showInventorySavedDialog(errorMsg: string) {

    var msg = errorMsg;
    if (!msg) {
      // if error empty than show success messate
      msg = this.translate.instant('COMMON.INVENTORY-UPDATED-MESSAGE');
    }

    // We use the same dialog of available balance just to keep the same style
    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // ok
      }

    });
  }

  checkIfHasTodoTreatments(customerID?: number) {

    console.log('checkIfHasTodoTreatments: ' + customerID);
    this.hasTreatmentsTodo = false;
    if (!customerID) {
      return;
    }

    this.findTimeService.hasTreatmentsTodo(customerID)
      .subscribe(
        result => {
          if (result.Code === ApiResponseCode.Success) {
            this.hasTreatmentsTodo = result.Data.hasToDoTreatment;
          } else {
            this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
          }
        },
        error => {
          this.error = error;
        }
      );
  }

  onSelectVisitReason(data) {
    this.appData.arguments = data.args;
    this.router.navigate([data.feature]);     // navigate to 'select-from-pricelist' or 'select-from-card'
  }

  onClearPriceListCode(priceListCode) {
    console.log('onClearPriceListCode');
    this.appData.removeFromPriceListCodes(priceListCode.PriceListRefID);
    this.getSelectedVisitReasons();
    this.updateDurationAndEndTime();
    this.cdr.detectChanges(); // fix issue that child component not re-rendered
    this.cdr.markForCheck();

  }

  onClearTreatment(treatment) {
    // remove the teratment from local list
    this.treatments = this.treatments.filter(x => x.ID != treatment.ID);

    // update appointment Treatments
    this.appointment.Treatments = this.treatments;

    // save changes in the saved treatments
    this.appData.treatments = this.treatments;

    // save changed in saved priceListCodes
    this.appData.priceListCodes = this.priceListCodes;

    // update treatmentsFromCard 
    this.treatmentsFromCard_UnatachFromAppointment(treatment);


    //this.appData.removeFromTreatments(treatment.ID);
    this.getSelectedVisitReasons();
    this.updateDurationAndEndTime();
    this.cdr.detectChanges(); // fix issue that child component not re-rendered
    this.cdr.markForCheck();
  }

  onClearVisitReason(data) {
    this.appData.treatments = this.treatments = null;
    this.appData.priceListCodes = this.priceListCodes = null;
    this.treatmentsFromCard_UnatachAllFromAppointment()
    this.updateDurationAndEndTime();
    this.cdr.detectChanges(); // fix issue that child component not re-rendered
    this.cdr.markForCheck();
  }

  getSelectedVisitReasons(): any[] {
    console.log('getSelectedVisitReasons');
    const reasons: any[] = [];
    this.treatments = this.appData.treatments || [];
    this.priceListCodes = this.appData.priceListCodes || [];

    if (this.priceListCodes.length > 0) {
      this.priceListCodes.forEach(element => {
        reasons.push(element);
      });
    }

    if (this.treatments.length > 0) {
      this.treatments.forEach(element => {
        reasons.push(element);
      });
    }

    if (reasons && reasons.length > 0) {
      //this.f.reason.setValue(reasons);

      var combinedTreatmentDuration = 0;
      reasons.forEach(element => {
        if (element.Duration) { // treatments from pricelist expose duration directly
          combinedTreatmentDuration += element.Duration;
        } else if (element.PriceListCode) { // treatments from card expose duration form within PriceListCode object.
          combinedTreatmentDuration += element.PriceListCode.Duration;
        }
      });
      this.setDuration(combinedTreatmentDuration);

    } else {
      //this.f.reason.setValue(null);
    }

    return reasons;
  }

  calcDurationByTreatments() {

    if (this.appointment == null) return;
    if (this.schedulers == null) return;

    var scheduler = this.schedulers.find(x => x.ID == this.appointment.SchedulerID);
    if (scheduler == null || !scheduler.NoMandatoryVisitReason)
      return; //if here the user cannot add/update treatments.

    // update duration
    var durationInMinutes = 0;
    if (this.treatments?.length > 0) {
      this.treatments.forEach(trt => {
        durationInMinutes += trt.PriceListCode?.Duration ?? 0;
      });
    }
    this.priceListCodes?.forEach(plc => {
      durationInMinutes += plc.Duration;
    });

    if (durationInMinutes == 0)
      durationInMinutes = this.appointment.Duration;

    return durationInMinutes;
  }



  onDurationChanged() {
    console.log('onDurationChanged');
    let duration = this.f.duration.value;
    if (duration % 5 !== 0) {
      this.setDuration(duration - (duration % 5));
    }
  }

  setDuration(duration: number) {
    if (duration > 0) {
      this.f.duration.setValue(duration);
      this.start = moment(this.appointment.Start)
        .startOf('day') // only date part
        .add(this.appointment.Hours, 'hours')
        .add(this.appointment.Minutes, 'minutes');
      this.end = moment(this.start).add(duration, 'minutes');
    }
  }

  toggleRoomRequiredValidator() {
    const control = this.form.get('room');

    if (control) {
      this.schedulers = this.appData.Schedulers || [];
      const scheduler = this.schedulers.find(x => x.ID == this.schedulerID);
      this.isRoomRequired = scheduler?.IsRoomRequired ?? false;

      if (this.isRoomRequired) {
        //control.addValidators(Validators.required);
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      } else {
        const currentValidators = control.validator ? [control.validator] : [];
        const updatedValidators = currentValidators.filter(validatorFn => validatorFn !== Validators.required);
        control.setValidators(null);
        control.updateValueAndValidity();
      }
    }
  }
}





